import { IContractLine, ContractLine } from "../../ContractLine";
import { mapData } from "@/utilities/DataMapping";

export interface IContractLineGroupVM {
    description: string;
    colour: string;
    lines: Array<IContractLine>;
}

export class ContractLineGroupVM implements IContractLineGroupVM {

    constructor(data?: IContractLineGroupVM) {
        if (data) this.update(data);
    }

    update(data: IContractLineGroupVM): void {
        mapData(data, { 
            root: () => this,
            lines: () => new ContractLine()
        });
    }

    description: string = "";
    colour: string = "";
    lines: Array<ContractLine> = [];
}
